var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-check",
  "use": "ring-icon-check-usage",
  "viewBox": "0 0 37 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 32\" id=\"ring-icon-check\"><path d=\"M27.482 4.581c-6.431 5.197-5.196 4.176-13.51 11.821-2.895-2.094-3.945-2.921-8.112-5.017-.517.492-1.176 1.192-1.176 1.192s4.75 7.413 9.411 13.112c5.677-7.458 6.204-8.284 14.884-19.67-.445-.445-.981-.897-1.497-1.439z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id